<div class="breadcrumb">
  <button type="button" (click)="goBack()">‹ 返回订单记录</button>
  <span>/</span><span>{{ tab === 1 ? "申请退款" : "退款详情" }}</span>
</div>

<div class="page-head">
  <h1>{{ tab === 1 ? "申请退款" : "退款详情" }}</h1>
  <p>
    {{
      tab === 1
        ? "确认退款方式并填写原因，提交后由工作人员人工审核。"
        : "您的退款申请记录与售后沟通明细。"
    }}
  </p>
</div>

<div class="notice-bar">
  <svg
    class="notice-icon"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01" />
    <path d="M11 12h1v4h1" />
  </svg>
  <div>
    <span class="notice-title">温馨提示：</span>客服回复后请在 48
    小时内跟进，逾期未回复将自动取消申请。
  </div>
</div>

<div class="refund-card">
  <!-- 订单信息 -->
  <div class="order-bar">
    <div class="ob-logo">
      <app-image
        [fileid]="order.bus_type_snapshot.platform.icon"
        [radius]="8"
      ></app-image>
    </div>
    <div class="order-copy" style="flex: 1">
      <h2>{{ order.bus_type_snapshot.platform.name }}</h2>
      <p>订单号 {{ order.id }} · 支付金额 ¥{{ order.pay_price }}</p>
    </div>
  </div>

  <!-- 步骤A: 申请表单 -->
  <ng-container *ngIf="tab === 1">
    <form class="form-body">
      <div class="section">
        <div class="section-title">
          <h3>退款方式</h3>
          <span>请选择一项</span>
        </div>
        <div class="method-grid">
          <button
            type="button"
            class="method-card"
            [class.active]="method === 'origin'"
            [disabled]="payScoreUsed"
            (click)="selectMethod('origin')"
          >
            <span class="method-top">
              <span class="radio"></span>
              <span class="method-text"
                ><strong>原路退回</strong
                ><span>{{
                  payScoreUsed
                    ? "钱包支付订单仅支持退回钱包"
                    : "退回原支付账户，扣除通道费"
                }}</span></span
              >
            </span>
            <span class="method-bottom">
              <span> 手续费 ¥{{ (order.pay_price * 0.1).toFixed(2) }} </span>
              <strong>¥{{ order.pay_price }}</strong>
            </span>
          </button>
          <button
            type="button"
            class="method-card"
            [class.active]="method === 'wallet'"
            (click)="selectMethod('wallet')"
          >
            <span class="method-top">
              <span class="radio"></span>
              <span class="method-text">
                <strong>退回网站钱包</strong>
                <span>免手续费，可用于下次购买</span>
              </span>
            </span>
            <span class="method-bottom"
              ><span>手续费 ¥0.00</span
              ><strong>¥{{ order.pay_price }}</strong></span
            >
          </button>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <h3>退款原因</h3>
          <span>必填</span>
        </div>
        <textarea
          class="reason-box"
          [(ngModel)]="reason"
          name="reason"
          maxlength="300"
          placeholder="请简单说明退款原因，例如：买错商品、账号无法登录等。"
          (input)="onReasonChange()"
        ></textarea>
        <div class="field-meta">
          <span class="error-text" [class.show]="reasonError">
            请填写退款原因
          </span>
          <span>{{ reason.length }}/300</span>
        </div>
      </div>

      <div class="submit-bar">
        <div class="refund-amount">
          <span>审核通过后预计退款</span>
          <strong>{{ currentAmount.toFixed(2) }}</strong>
        </div>
        <button
          class="primary-btn"
          type="submit"
          [disabled]="loading"
          (click)="submitRefund()"
        >
          {{ loading ? "提交中..." : "提交申请" }}
        </button>
      </div>
    </form>
  </ng-container>

  <!-- 步骤B: 已提交售后工单 -->
  <ng-container *ngIf="tab === 2">
    <div class="status-panel">
      <div class="status-head">
        <div class="status-icon" [ngClass]="statusTone">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </div>
        <div class="status-copy" style="flex: 1">
          <h2>{{ statusText }}</h2>
          <p>工作人员审核后会在下方回复，请留意消息。</p>
        </div>
        <span class="status-tag" [ngClass]="statusTone">{{ statusTag }}</span>
      </div>
      <div class="summary-strip">
        <div class="summary-item">
          <span>退款方式</span
          ><strong>{{
            this.method === "origin" ? "原路退回" : "退回网站钱包"
          }}</strong>
        </div>
        <div class="summary-item">
          <span>预计退款</span><strong>￥{{ currentAmount.toFixed(2) }}</strong>
        </div>
      </div>
    </div>

    <div class="chat-section">
      <div class="chat-title">
        售后沟通
        <span><i class="status-dot"></i>等待回复</span>
      </div>
      <div class="chat-box">
        <div class="chat-messages">
          <div class="chat-time">刚刚</div>
          <ng-container *ngFor="let item of logs">
            <div class="message-row user" *ngIf="item.sender_type === 'user'">
              <div class="chat-avatar customer-avatar">我</div>
              <div class="message-column">
                <div class="bubble">
                  <!-- <span class="bubble-strong">已提交退款申请</span>
                <div class="bubble-meta">
                  <span>退款方式</span
                  ><span>{{
                    this.method === "origin" ? "原路退回" : "退回网站钱包"
                  }}</span>
                </div>
                <div class="bubble-meta">
                  <span>预计退款</span
                  ><span>￥{{ currentAmount.toFixed(2) }}</span>
                </div> -->
                  <div class="bubble-reason">{{ item.content }}</div>
                </div>
              </div>
            </div>
            <div class="message-row" *ngIf="item.sender_type !== 'user'">
              <div class="chat-avatar customer-avatar">
                <img
                  src="../../../../assets/images/环球巴士.png"
                  width="16"
                  height="16"
                  alt=""
                />
              </div>
              <div class="message-column">
                <div class="bubble">
                  <div class="bubble-reason">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="chat-composer">
          <input
            class="composer-input"
            type="text"
            [(ngModel)]="replyText"
            [placeholder]="canReply ? '请输入回复内容' : '等待工作人员回复'"
            [disabled]="!canReply"
            (keyup.enter)="sendReply()"
          />
          <button
            class="composer-send"
            type="button"
            [disabled]="!canReply || !replyText.trim() || sending"
            (click)="sendReply()"
          >
            {{ sending ? "发送中..." : "发送" }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
